import store from '@/store';
import { p2pActions } from '@/store/p2p-slice';

import { sendP2PSocketData } from './p2pConnection';

let getPeerTimer = null;

export const errorPeerConnectHandler = (clearTimer: boolean = false) => {
    if (clearTimer && getPeerTimer) {
        return clearTimeout(getPeerTimer);
    }
    const isInUploadKeyPage = store.getState().p2pReducer.isInUploadKeyPage;

    store.dispatch(
        p2pActions.updatePeerFound('Error Connecting with the peer'),
    );

    if (isInUploadKeyPage && !getPeerTimer) {
        getPeerTimer = setTimeout(() => {
            sendP2PSocketData({
                command: 'getpeer',
                data: [],
            });
        }, 6000);
    }
};
